var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParentRightArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.83391 14.0652C0.83391 14.2967 0.921523 14.5315 1.09237 14.7071C1.43439 15.0586 1.99993 15.0586 2.34195 14.7071L8.74194 8.1304C8.90713 7.96065 9.00041 7.72117 9.00041 7.48852C9.00041 7.25806 8.91878 7.02837 8.74194 6.84665L2.35016 0.278938C2.01317 -0.088996 1.43428 -0.0937176 1.09226 0.257748C0.750242 0.609212 0.750242 1.19037 1.09226 1.54183L1.09247 1.54205L6.87922 7.47677L1.0922 13.4236C0.921034 13.5995 0.83374 13.8343 0.83374 14.0655L0.83391 14.0652Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentRightArrow);
export default __webpack_public_path__ + "static/media/parent-right-arrow.61e1ac426799fa0f3b37f7281df35af6.svg";
export { ForwardRef as ReactComponent };